import React from 'react'

interface CrossProps {
  className?: string
  style?: object
}

export default function Cross(
  props: CrossProps,
): React.ReactElement<React.ReactSVGElement> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120.19 120.06"
      {...props}
    >
      <path
        d="M100.87,81.2,134.06,48a15.77,15.77,0,0,0,0-22.29,16.12,16.12,0,0,0-22.29,0L78.58,58.9,45.39,25.72a16.14,16.14,0,0,0-22.3,0,15.79,15.79,0,0,0,0,22.29L56.28,81.2,23.09,114.39a15.8,15.8,0,0,0,0,22.3,16.16,16.16,0,0,0,22.3,0l33.19-33.2,33.19,33.2a15.76,15.76,0,0,0,22.29-22.3Z"
        transform="translate(-18.48 -21.25)"
      />
    </svg>
  )
}
